<template>
  <a
    :href="foreverDomainUrl"
    target="_blank"
    class="w-full"
  >
    <img
      :src="Image"
      alt="kakao-talk"
      class="w-full"
    >
  </a>
</template>
<script setup>
import Image from '@/assets/decals/forever-domain.png'
import { useDecal } from '@/composables/useDecal.js'

const { foreverDomainUrl } = useDecal()
</script>
